import { useState, type ReactNode } from 'react';

export interface RenderConfirmationModalProps {
  onCancel: () => void;
  onConfirm: (reason?: string) => void;
  open: boolean;
}

export const useConfirm = (
  shouldWarn: boolean,
  onConfirm: (reason?: string) => void,
  renderModal: (props: RenderConfirmationModalProps) => ReactNode,
  shouldCloseModalAfterConfirm?: boolean,
) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');

  const handleConfirm = (reason?: string) => {
    // First run: To trigger the modal open
    if (shouldWarn && !open) {
      setOpen(true);
      setReason(reason || '');
      return;
    }

    // Second run: Define reason type to return callback for Confirm Action
    onConfirm(reason);
    shouldCloseModalAfterConfirm && setOpen(false);
  };

  const ConfirmModalWrapper = () => {
    return renderModal({
      onCancel: () => setOpen(false),
      onConfirm: () => handleConfirm(reason),
      open,
    });
  };

  return {
    ConfirmModalWrapper,
    onConfirm: handleConfirm,
  };
};
